const backendUrl = process.env.REACT_APP_API_URL || 'http://localhost:3001';
const frontendUrl = window.location.origin;

const config = { backendUrl, frontendUrl };

export default config;